import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GoMarkGithub, GoRepoForked } from "react-icons/go";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>
            <ul className="footer-icons">
              <li className="social-icons">
              
                Forked from soumyajit4419&nbsp;
                <a
                  href="https://github.com/soumyajit4419/Portfolio"
                  style={{ color: "white" }}
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <GoRepoForked />
                </a>
              </li>
            </ul>
          </h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} Russell Banks</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/russellbanks"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <GoMarkGithub />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
